import { render } from "./routeRenderer.vue?vue&type=template&id=4aafe10b"
import script from "./routeRenderer.vue?vue&type=script&lang=js"
export * from "./routeRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__